import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import _pick from 'lodash/pick';
import _omit from 'lodash/omit';
import React from 'react';
import PropTypes from 'prop-types';
import { MortgageCalculator as MortgageCalculator$1, MortgageCalculatorShape } from '@zillow/zrs-cms';

var BlockMortgageCalculator = function BlockMortgageCalculator(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  return /*#__PURE__*/React.createElement(MortgageCalculator$1, _extends({
    defaultValues: _pick(attrs, Object.keys(MortgageCalculatorShape))
  }, _omit(attrs, Object.keys(MortgageCalculatorShape)), {
    key: index
  }));
};
BlockMortgageCalculator.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  attrs: PropTypes.shape(MortgageCalculatorShape)
} : {};
var MortgageCalculator = BlockMortgageCalculator;

export { MortgageCalculator as default };
